export const CATEGORY_META = [
  { key: "seo", label: "SEO" },
  { key: "performance", label: "Performance" },
  { key: "mobile", label: "Mobile" },
  { key: "accessibility", label: "Accessibility" },
  { key: "content", label: "Content" },
  { key: "conversion", label: "Conversion" },
  { key: "security", label: "Security" },
  { key: "ai_readiness", label: "AI Readiness" },
];

export const CAPABILITIES = [
  { title: "AI", desc: "Assistants, semantic search and content that understand your business." },
  { title: "SEO", desc: "Technical, on-page and AI-search visibility that compounds over time." },
  { title: "Analytics", desc: "Visitor, lead and revenue intelligence in one measurable layer." },
  { title: "Automation", desc: "Leads, bookings, reviews and content flows that run themselves." },
  { title: "Interactive Apps", desc: "Directories, portals, marketplaces and calculators built in." },
  { title: "Multilingual", desc: "Localized content and SEO for customers in every market." },
  { title: "Conversion", desc: "Every page engineered to turn visitors into qualified leads." },
  { title: "Security", desc: "HTTPS, hardening, monitoring and privacy-first architecture." },
];

export const PHILOSOPHY = [
  { n: "01", title: "Build", desc: "Design and develop a modern, fast, accessible platform on the right technology." },
  { n: "02", title: "Modernize", desc: "Keep valuable content, replace outdated technology, preserve SEO and URLs." },
  { n: "03", title: "Automate", desc: "Wire up CRM, email, bookings and content workflows so growth compounds." },
  { n: "04", title: "Measure", desc: "Instrument traffic, leads, conversions and health with clear reporting." },
  { n: "05", title: "Grow", desc: "Continuously optimize with AI insights, SEO and conversion experiments." },
];

export const PROCESS = [
  { n: "1", title: "Discover", desc: "Understand your business, goals and audience." },
  { n: "2", title: "Analyze", desc: "Audit current systems, SEO and performance." },
  { n: "3", title: "Plan", desc: "Create a website blueprint and module map." },
  { n: "4", title: "Build", desc: "Develop a modern, measurable platform." },
  { n: "5", title: "Launch", desc: "Deploy, validate and hand over dashboards." },
  { n: "6", title: "Measure", desc: "Track performance, leads and conversions." },
  { n: "7", title: "Improve", desc: "Continuous optimization powered by AI." },
];

export const INDUSTRIES = [
  {
    slug: "restaurants",
    name: "Restaurants",
    modules: "Menus • Reservations • Reviews • Local SEO",
    image:
      "https://images.unsplash.com/photo-1583354608715-177553a4035e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjByZXN0YXVyYW50JTIwaW50ZXJpb3IlMjBkYXJrfGVufDB8fHx8MTc4NzgwMDIxMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "healthcare",
    name: "Healthcare",
    modules: "Doctors • Appointments • Multilingual • Accessibility",
    image:
      "https://images.unsplash.com/photo-1631507623112-0092cef9c70d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBoZWFsdGhjYXJlJTIwY2xpbmljJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzg3ODAwMjEwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "travel",
    name: "Hotels & Travel",
    modules: "Bookings • Galleries • Multilingual • Maps",
    image:
      "https://images.unsplash.com/photo-1650965171703-087486b3a1b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3RlbCUyMHJlc29ydCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODc4MDAyMTB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "professional",
    name: "Professional Services",
    modules: "Lead Capture • Booking • Content • Automation",
    image:
      "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnZW9tZXRyaWN8ZW58MHx8fHwxNzg3Nzk5OTQ1fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const CASE_STUDIES = [
  {
    company: "Coastline Dental Group",
    industry: "Healthcare",
    challenge: "Outdated, non-responsive site with no online booking and poor local visibility.",
    metrics: [
      { label: "SEO", from: 61, to: 94 },
      { label: "Performance", from: 43, to: 91 },
      { label: "Conversion", from: 38, to: 79 },
      { label: "Mobile", from: 67, to: 98 },
    ],
    image:
      "https://images.unsplash.com/photo-1735469157670-1212e570eadc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxkYXJrJTIwYW5hbHl0aWNzJTIwZGFzaGJvYXJkJTIwc2NyZWVufGVufDB8fHx8MTc4NzgwMDIxMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    company: "Marino Trattoria",
    industry: "Restaurant",
    challenge: "No reservations, thin content and zero structured data for local search.",
    metrics: [
      { label: "SEO", from: 55, to: 92 },
      { label: "Performance", from: 52, to: 95 },
      { label: "Conversion", from: 31, to: 71 },
      { label: "Mobile", from: 60, to: 97 },
    ],
    image:
      "https://images.unsplash.com/photo-1583354608715-177553a4035e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjByZXN0YXVyYW50JTIwaW50ZXJpb3IlMjBkYXJrfGVufDB8fHx8MTc4NzgwMDIxMHww&ixlib=rb-4.1.0&q=85",
  },
];

export const PRICING = [
  { name: "Website Audit", price: "Free", note: "Preliminary audit", features: ["WebsiteTech Score", "8 category breakdown", "Prioritized opportunities"], highlight: false },
  { name: "Starter Website", price: "$1,500", note: "From", features: ["Modern responsive build", "Core SEO setup", "Lead capture form"], highlight: false },
  { name: "AI Website", price: "$5,000", note: "From", features: ["AI assistant + search", "Automation workflows", "Analytics dashboard"], highlight: true },
  { name: "Modernization", price: "$2,500", note: "From", features: ["Redesign + migration", "SEO & URL preservation", "Performance overhaul"], highlight: false },
];

export const NAV = [
  {
    label: "Build",
    items: ["New Website", "AI Website", "Ecommerce", "Web Applications", "Website Redesign"],
  },
  {
    label: "Improve",
    items: ["Website Audit", "SEO", "Performance", "Accessibility", "Conversion Optimization"],
  },
  {
    label: "AI",
    items: ["AI Assistants", "AI Content", "AI Search", "AI Analytics", "Automation"],
  },
  {
    label: "Solutions",
    items: ["Restaurants", "Healthcare", "Hotels & Travel", "Professional Services", "Ecommerce"],
  },
  {
    label: "Company",
    items: ["About", "Portfolio", "Case Studies", "Pricing", "Contact"],
  },
];

export const FOUNDER = {
  image:
    "https://images.pexels.com/photos/28446973/pexels-photo-28446973.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bio: "WebsiteTech.pro was founded on decades of hands-on experience spanning software programming, database engineering, website publishing and digital business operations. That journey — from traditional programming and CMS publishing into AI-assisted platform development — shapes how we build today: websites are no longer brochures, they are intelligent systems that operate and grow a business.",
};
